import * as React from 'react';
const SvgNavionicsIcon = (props: React.SVGAttributes<SVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={36} height={36} viewBox="0 0 36 36" {...props}>
    <path
      fill="currentColor"
      d="m16.592 15.018 3.209 3.815c.666.787 1.756.787 2.422 0l9.628-11.474a17.373 17.373 0 0 0-3.542-3.451l-6.085 7.236c-.666.817-1.756.817-2.422 0l-3.209-3.815c-.666-.787-1.756-.787-2.422 0L1.182 22.799a17.557 17.557 0 0 0 2.301 4.935L14.17 15.018c.666-.787 1.756-.787 2.422 0"
    />
    <path
      fill="currentColor"
      d="m16.622 4.966 3.179 3.815c.666.787 1.756.787 2.422 0l4.784-5.722C24.373 1.485 21.285.546 18.015.546 8.387.546.546 8.357.546 17.985c0 .999.091 1.968.242 2.907L14.2 4.936c.666-.757 1.726-.757 2.422.03M16.622 25.069l3.179 3.845c.666.787 1.756.787 2.422 0l12.716-15.168a17.678 17.678 0 0 0-2.18-5.086L22.223 21.224c-.666.787-1.756.787-2.422 0l-3.179-3.815c-.666-.787-1.756-.787-2.422 0L4.451 29.005a17.44 17.44 0 0 0 3.633 3.361L14.2 25.07c.666-.787 1.756-.787 2.422 0Z"
    />
    <path
      fill="currentColor"
      d="M35.303 15.654 22.224 31.276c-.666.817-1.756.817-2.422 0l-3.209-3.815c-.666-.787-1.756-.787-2.422 0l-4.814 5.722a17.305 17.305 0 0 0 8.628 2.271c9.628 0 17.469-7.811 17.469-17.469 0-.787-.061-1.574-.151-2.331"
    />
  </svg>
);
export default SvgNavionicsIcon;
